import { cn } from '@/lib/utils';
import icon from '/brand/ribox-icon.png';

export interface BrandMarkProps {
  /** Drops the wordmark for the 52px rail and the mobile bar. */
  compact?: boolean;
  className?: string;
}

/**
 * The Ribox lockup: the chameleon app icon plus the RIBOX wordmark.
 *
 * The icon ships as RCREA's exported artwork rather than a redrawn SVG — it
 * carries a gradient body over a gradient plate, and a logo is the one place
 * where "close enough" is wrong. It brings its own dark plate, so it never
 * takes `currentColor` and reads the same on either theme.
 *
 * The wordmark is Michroma, which the manual reserves for exactly this. It is
 * uppercase-only and very wide, so it appears here and nowhere else.
 */
export function BrandMark({ compact = false, className }: BrandMarkProps) {
  return (
    <span className={cn('flex items-center gap-2', className)}>
      <img
        src={icon}
        alt="Ribox"
        width={28}
        height={28}
        className="size-7 shrink-0 select-none rounded-[7px]"
        draggable={false}
      />
      {!compact && (
        <span
          className="truncate text-[13px] leading-none tracking-[0.04em]"
          style={{ fontFamily: "'Michroma', var(--font-display)" }}
        >
          RIBOX
        </span>
      )}
    </span>
  );
}
